import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { AdminState } from './types';

export const getters: GetterTree<AdminState, RootState> = {
  publicInfrastructureJobs(state): any[] {
    return state.publicInfrastructureJobs;
  }
};
